export default {
  props: ['format', 'option'],
  setup(props: Record<any, any>) {
    return () => props.format(props.option)
  }
}
